<div class="logo-animations">
  <ng-lottie width="100px" [options]="options"></ng-lottie>
  <div class="loading-state">
    <h1 class="h1-headers primary-0">{{ title }}</h1>
    <h3 class="h3-bold primary-0 text-center">{{ message }}</h3>
  </div>
</div>
